import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { API } from '../../utils';
import { count } from '../../utils/sendStats';
import { configTransformer } from '../../transformer';
import Scroller from '../Scroller';
import MenuPanel from './MenuPanel';

const METRIC_PREFIX = 'navigation_menu';

class NavigationMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            config: props.config,
        };
    }

    componentDidMount() {
        count(`${METRIC_PREFIX}.should_pre_render.${this.props.shouldPreRender}`);
        const hasFullConfig = !!this.state.config.level_2;

        !this.props.shouldPreRender &&
            !hasFullConfig &&
            axios
                .get(API.FETCH_NAVIGATION_CONFIG)
                .then((res) => {
                    const { config } = res.data;
                    this.setState({
                        config: {
                            ...this.state.config,
                            ...configTransformer(config, this.props.locale, this.props.mode),
                        },
                    });

                    count(`${METRIC_PREFIX}.ajax.lazy.succeeded`);
                })
                .catch((error) => {
                    error.description = 'Failed to fetch category navigation items';
                    logger.error(error);
                    count(`${METRIC_PREFIX}.ajax.lazy.failed`);
                });
    }

    componentDidUpdate(prevProps) {
        if (this.props.config !== prevProps.config) {
            this.setState({ config: this.props.config });
        }
    }

    render() {
        const { theme, shouldPreRender, mode, currency } = this.props;
        const { config } = this.state;
        const { level_1 = {} } = config;

        const shouldShowPostBriefCta = false;
        const ctaSource = shouldShowPostBriefCta ? 'nav_bar_left' : 'none';

        return (
            <Scroller
                classname={theme}
                mode={mode}
                currency={currency}
                shouldShowPostBriefCta={shouldShowPostBriefCta}
                ctaSource={ctaSource}
            >
                {level_1[0]?.map((panel) => (
                    <MenuPanel
                        key={panel.id}
                        mode={mode}
                        item={panel}
                        config={config}
                        shouldPreRender={shouldPreRender}
                        shouldShowPostBriefCta={shouldShowPostBriefCta}
                        eventTracker={{ vertical: panel.displayName, entry: panel.displayName }}
                    />
                ))}
            </Scroller>
        );
    }
}

NavigationMenu.propTypes = {
    config: PropTypes.object,
    theme: PropTypes.string,
    mode: PropTypes.string,
    locale: PropTypes.string,
    shouldPreRender: PropTypes.bool,
    currency: PropTypes.object,
};

NavigationMenu.defaultProps = {
    mode: 'default',
    shouldPreRender: true,
};

export default NavigationMenu;
